<ng-container *ngIf="data.type == 'dlv_mod'; else nonDlV">
  <h1>Delivery Modifiers</h1>
</ng-container>
<ng-template #nonDlV>
  <ng-container *ngIf="data.type == 'cloneAdv'; else bulkEdit"> </ng-container>
  <ng-template #bulkEdit>
    <h1>Bulk Edit: {{ data.type.split("_").join(" ") | titlecase }}</h1>
  </ng-template>
</ng-template>

<div
  *ngIf="
    (isItemRunning || isEveryLiEnded ||
      (!isAllDailyPacing && isPacingAvailable) ||
      areDiffActions['country'] ||
      areDiffActions['zip'] ||
      !isSameBudgetType) &&
    data.type != 'dlv_mod'
  "
  class="warning_message scroll-warning"
>
  <ol>
    <li *ngIf="isItemRunning">
      One or more {{ data.type.split("_").join(" ") }}(s) have start dates in
      the past, so they cannot be updated in bulk. Please ensure that all start
      dates are set to either the present or a future date.
    </li>
    <li *ngIf="!isAllDailyPacing && isPacingAvailable">
      One or more {{ data.type.split("_").join(" ") }}(s) have pacing other than
      daily ahead/daily even, so daily budget cannot be updated in bulk. Please
      ensure that pacings are set to either daily ahead/daily even.
    </li>
    <li *ngIf="areDiffActions['country']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different country
      action, so geo cannot be updated in bulk. Please ensure that country
      action is same for all the selected items.
    </li>
    <li *ngIf="areDiffActions['operating']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different os
      action, so OS targeting cannot be updated in bulk. Please ensure that os
      action is same for all the selected items.
    </li>
    <li *ngIf="areDiffActions['ads_txt']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different ads txt
      action, so OS targeting cannot be updated in bulk. Please ensure that ads
      txt action is same for all the selected items.
    </li>
    <li *ngIf="areDiffActions['audio_start_delay']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different audio
      start delay action, so Audio start delay targeting cannot be updated in
      bulk. Please ensure that audio start delay action is same for all the
      selected items.
    </li>
    <li *ngIf="areDiffActions['native_layout']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different native
      layout action, so native layout targeting cannot be updated in bulk.
      Please ensure that native layout action is same for all the selected
      items.
    </li>
    <li *ngIf="areDiffActions['player_size']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different player
      size action, so player size targeting cannot be updated in bulk. Please
      ensure that player size action is same for all the selected items.
    </li>
    <li *ngIf="areDiffActions['start_delay']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different start
      delay action, so start delay targeting cannot be updated in bulk. Please
      ensure that start delay action is same for all the selected items.
    </li>
    <li *ngIf="areDiffActions['video_placement_type']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different video
      placement type, so video placement type targeting cannot be updated in
      bulk. Please ensure that video placement action is same for all the
      selected items.
    </li>
    <li *ngIf="areDiffActions['playback_method']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different
      playback method action, so playback method targeting cannot be updated in
      bulk. Please ensure that playback method action is same for all the
      selected items.
    </li>
    <li *ngIf="areDiffActions['zip']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different postal
      code action, so geo cannot be updated in bulk. Please ensure that postal
      action is same for all the selected items.
    </li>
    <li *ngIf="!isSameBudgetType">
      One or more {{ data.type.split("_").join(" ") }}(s) have have different
      budget type. Hence, budget cannot be updated in bulk. Make sure all the
      selection {{ data.type.split("_").join(" ") }} have same budget type.
    </li>
    <li *ngIf="areDiffActions['interstitial']">
      One or more {{ data.type.split("_").join(" ") }}(s) have different
      interstitial action, so interstitial targeting cannot be updated in
      bulk. Please ensure that interstitial action is same for all the
      selected items.
    </li>
    <li *ngIf="isEveryLiEnded">
      All selected Line Items have already ended and cannot be edited.
      <ng-container *ngIf="data?.dspType === 'bdsp'">
        Only <strong>End Date</strong> can be edited.
        To edit other fields, please update the <strong>End Date</strong> to a future date.
      </ng-container>
    </li>
  </ol>
</div>

<ng-container *ngIf="data.type != 'dlv_mod'">
  <app-items-for-bulk-edit
    *ngIf="showSelectedItem"
    [selectedItems]="data.selectedItems"
    [entityType]="data.type"
    [clientCurrency]="clientCurrency"
    [dspType]="dspType"
    [clientTimeZone]="clientTimeZone"
    step="all"
    [isBulkEdit]="true"
  >
  </app-items-for-bulk-edit>
</ng-container>

<ng-container *ngIf="data.type != 'cloneAdv'">
  <div class="field-name mt-1">
    Select the fields you want to edit. Changes made will be applied to all the
    selected {{ data.type.split("_").join(" ") }}(s):
  </div>

  <div class="field-selection">
    <mat-selection-list
      class="grid-selection-list error"
      [(ngModel)]="selectedFields"
      (selectionChange)="data.type != 'dlv_mod' ? validate() : ''"
    >
      <mat-list-option
        *ngFor="let field of this.fields"
        [disabled]="
          data.type != 'dlv_mod'
            ? field.disable
            : selectedFields.length == 3 && !selectedFields.includes(field.key)
        "
        [value]="field.key"
        checkboxPosition="before"
      >
        <span
          [ngClass]="{
            capitalize: true,
            inactive:
              data.type != 'dlv_mod'
                ? field.disable == true
                : selectedFields.length == 3 &&
                  !selectedFields.includes(field.key)
          }"
        >
          {{ field.label.split("_").join(" ") | titlecase }}</span
        >
      </mat-list-option>
    </mat-selection-list>
  </div>
</ng-container>

<ng-container *ngIf="data.type == 'cloneAdv'">
  <div class="field-name mt-4">Where would you like to duplicate the advertiser ?</div>
  <mat-radio-group [(ngModel)]="selectedDSP">
    <mat-radio-button *ngIf="data.source != 'tdsp' && tdspEnabled" value="tdsp">
      Global</mat-radio-button>
    <mat-radio-button *ngIf="data.source != 'adsp_us' && isAdspUS && adspEnabled"
      value="adsp_us">US Amazon</mat-radio-button>
    <mat-radio-button *ngIf="data.source != 'adsp_eu' && isAdspEU && adspEnabled"
      value="adsp_eu">EU Amazon</mat-radio-button>
    <mat-radio-button *ngIf="data.source != 'bdsp' && bdspEnabled" value="bdsp">
      Restricted Inventory</mat-radio-button>
  </mat-radio-group>
</ng-container>

<div class="preview_dailog_action_buttons mb-1">
  <button mat-button (click)="closeModal()" class="delete-action-btn">
    Cancel
  </button>

  <button
    mat-button
    [disabled]="data.type == 'cloneAdv' ? false : selectedFields.length == 0"
    (click)="proceed()"
    [ngClass]="{
      'create-btn': true,
      'create-btn-disabled':
        data.type == 'cloneAdv' ? false : selectedFields.length == 0,
      'mb-3': true,
      'ms-3': true
    }"
  >
    Confirm
  </button>
</div>
